import { Controller } from "stimulus";

// Usage :
// <div data-controller="feature-tour"
//      data-feature-tour-configs-value="<%= raw @fx_applicable_tours.map(&:as_json_for_js).to_json %>"></div>

export default class extends Controller {
  static values = {
    config: Object,
    configs: Array,
  };

  connect() {
    if (!window.FxNoveltyTour) {
      console.warn("FxNoveltyTour engine not loaded yet");
      return;
    }

    if (this.hasConfigsValue && this.configsValue.length) {
      this.configsValue.forEach((cfg) => window.FxNoveltyTour.register(cfg));
    } else if (this.hasConfigValue && Object.keys(this.configValue).length) {
      window.FxNoveltyTour.register(this.configValue);
    }
  }
}